// extracted by mini-css-extract-plugin
module.exports = {"Panel":"css-modules_Panel__s9vNe","Button":"css-modules_Button__P9Eht","Popup":"css-modules_Popup__jDo35","Arrow":"css-modules_Arrow__DpSeT"};